import { render, staticRenderFns } from "./HomeProductShowcase.vue?vue&type=template&id=3af8f21a&"
import script from "./HomeProductShowcase.vue?vue&type=script&lang=js&"
export * from "./HomeProductShowcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports